import { NgModule } from '@angular/core';
import { MomentFormatPipe } from './moment.pipe';

@NgModule({
    declarations: [MomentFormatPipe],
    exports: [MomentFormatPipe],
})
export class MomentPipeModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/pipes/moment.pipe/moment.pipe.module.ts